import { useQuery } from '@tanstack/react-query';
import { getEVSEs } from '../../api/charging-service.ts';

export default function useEVSEs(serviceId: string) {
  return useQuery({
    queryKey: ['chargingServices', serviceId, 'evses'],
    queryFn: async () => {
      return await getEVSEs(serviceId);
    },
    enabled: !!serviceId,
  });
}
